import { useMutation } from 'query';
import { useUpdatePollVote } from '../../hooks';
import { removeVote } from '../../services';

type RemoveVote = { choice: string; pollId?: string };

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const useRemoveVoteMutation = () => {
  const updateCache = useUpdatePollVote({ action: 'unvote' });

  return useMutation<unknown, RemoveVote>({
    mutationFn: async ({ choice }) => removeVote(choice),
    onSuccess(_data, params) {
      updateCache(params);
    },
  });
};
